<template>
    <div id="privacy" class="section grow bg-svg-snow">
        <div class="overlay opacity-75"></div>
        <div class="container h-100">
            <div class="d-flex h-100 text-left align-items-center color-white">
                <div class="w-100">
                    <h1 class="title text-center color-white mb-10">Privacy Policy</h1>
                    <div class="col-md-12 ml-auto mr-auto">
                        <div class="row">

                            <div class="floater-wrapper col-lg-12 col-md-6 col-sm-6">
                                <div class="floater text-left color-white">
                                    <h5>General</h5>
                                    <p>This privacy policy is an agreement between you ("User", "You") and Invoked Apps LLC dba Sleep Jar ("Provider", "We", "Us") for the use of any services, products, or goods ("Works") offered by the Provider, including but not limited to the Provider's websites, Alexa Skills, and Google Actions. If you do not accept this privacy policy, you forfeit all rights and must not use any Works of the Provider.</p>

                                    <h5>Consent</h5>
                                    <p>By accepting this privacy policy, User represents that they are at least 18 years old or have reached the age of majority where they live, if that is more than 18 years of age. If User is under 18 or has not reached such age of majority, User's parent or legal guardian must accept these terms on User's behalf.</p>

                                    <h5>What information do we collect from you?</h5>
                                    <p>Provider may collect a User's name, email address, and usage statistics for the benefit of conducting business and/or improving the User's experience.</p>

                                    <h5>How do we collect your information?</h5>
                                    <p>We may collect your information through surveys, forms, registrations, purchases, and by general use of our Works.</p>

                                    <h5>How do we use your information?</h5>
                                    <p>We use your information to personalize and improve your experience in connection to our Works. We may also use your information to recommend other Works owned or not owned by us.</p>

                                    <h5>License and Security</h5>
                                    <p>User grants Provider and partnering entities an irrevocable license to data collected through the use of the Provider's Works for the purpose of conducting general business. In good faith, Provider has implemented reasonable security measures to protect the data, whether personal or anonymous.</p>

                                    <h5>Children's Online Privacy Protection Act (COPPA)</h5>
                                    <p>Unless otherwise noted, Provider does not specifically market to childeren under the age of 13 years old. Provider's Works may be used by children under the age of 13 years old with the consent (either direct or implied) of a parent or legal guardian.</p>

                                    <h5>Contact Information</h5>
                                    <p>If you have any questions regarding this privacy policy or our business practices, you may contact us at:
                                    <address>
                                    Sleep Jar<br/>
                                    51584 Cove Dr.<br/>
                                    South Lyon, MI 48178<br/>
                                    USA<br/>
                                    support@sleepjar.com
                                    </address>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto">
                        <p>Last modified February 22, 2021</p>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'privacy',
  metaInfo: {
      title: 'Privacy Policy'
  },
  components: {
  }
}
</script>
